import { Member } from 'components/views/single/resources/member'

export default function PageResources() {
	return <Member />
}
